<template>
  <v-dialog
    :value="true"
    width="40%"
    persistent
    scrollable
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <v-card>
      <v-card-title class="text-h3 primary--text"
        >EXTRACCIÓN DE MUESTRAS</v-card-title
      >
      <v-card-text>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs12>
              <v-autocomplete
                label="Tipo Extracción"
                :items="catalogos.ExtraccionTipos"
                v-model="extraccionTipo"
                item-text="ExtraccionTipo"
                item-value="ExtraccionTipoID"
              >
              </v-autocomplete>
            </v-flex>
            <v-flex xs12>
              <v-simple-table fixed-header height="400px">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left primary--text">
                        Código
                      </th>
                      <th class="text-left primary--text">
                        Fecha Toma
                      </th>
                      <th class="text-left primary--text">
                        Hora Toma
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody v-if="muestras.length === 0">
                    <td colspan="3">
                      <div class="ma-3">
                        Por favor lea las muestras a extraer ...
                      </div>
                    </td>
                  </tbody>
                  <tbody>
                    <tr v-for="m in muestras" :key="m.Codigo">
                      <td>{{ m.Codigo }}</td>
                      <td>{{ formatDate(m.FechaMuestra.split('T')[0]) }}</td>
                      <td>
                        {{ m.FechaMuestra.split('T')[1].substring(0, 5) }}
                      </td>
                      <td>
                        <v-btn
                          @click.prevent="borrarMuestra(m)"
                          icon
                          color="error"
                        >
                          <v-icon>close</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
        </v-container>
        <lector-codigos
          :desactivado="mostrarLecturaManual"
          @codigoLeido="leer"
        ></lector-codigos>

        <codigo-manual
          v-if="mostrarLecturaManual"
          @cerrar="cerrarCodigoManual"
        ></codigo-manual>
      </v-card-text>
      <v-card-actions>
        <v-btn class="mr-5" text @click.prevent="cerrar(false)">
          Cancelar</v-btn
        >
        <v-spacer> </v-spacer>
        <v-btn class="mr-5" text @click.prevent="lecturaManual"
          ><v-icon>add</v-icon> Lectura Manual</v-btn
        >
        <v-btn v-if="!!muestras.length" color="primary" @click.prevent="guardar"
          ><v-icon>save</v-icon> Extraer Muestras</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CodigoManual from '../../components/CodigoManual.vue';
import LectorCodigos from '../../components/LectorCodigos.vue';
import ServicioCatalogos from '../../services/catalogos';
import ServicioLaboratorio from '../../services/laboratorio';
export default {
  name: 'extraccion',
  components: {LectorCodigos, CodigoManual},
  data() {
    return {
      muestras: [],
      catalogos: {
        ExtraccionTipos: [],
      },
      extraccionTipo: null,
      mostrarLecturaManual: false,
    };
  },
  async mounted() {
    await this.cargarCatalogos();
    this.extraccionTipo = this.catalogos.ExtraccionTipos[0].ExtraccionTipoID;
  },
  methods: {
    cerrarCodigoManual(codigo) {
      if (codigo) {
        this.leer(codigo);
      }
      this.mostrarLecturaManual = false;
    },
    lecturaManual() {
      this.mostrarLecturaManual = true;
    },
    async cargarCatalogos() {
      let res = await ServicioCatalogos.getExtraccionTipos();
      this.catalogos.ExtraccionTipos = res.data.data.Table0;
    },
    async leer(codigo) {
      if (this.muestras.some((m) => m.Codigo === codigo)) {
        return (this.$root.mensajeError =
          'La muestra ya se encuentra en la lista.');
      }

      const res = await ServicioLaboratorio.extraccionCodigo(codigo);
      if (res.data.result === 1) {
        this.muestras.push({Codigo: codigo, ...res.data.data.Table0[0]});
      } else {
        this.$root.mensajeError = res.data.message;
      }
    },
    async guardar() {
      const muestras = this.muestras.map((m) => {
        return {
          MuestraDetalleID: m.MuestraDetalleID,
        };
      });
      const res = await ServicioLaboratorio.extraccionMuestras(
        this.extraccionTipo,
        muestras
      );
      if (res.data.result === 1) {
        this.$root.mensajeExito = 'La extracción se realizó con éxito';
        this.cerrar(true);
      } else {
        this.$root.mensajeError =
          res.data.message || 'Error en el proceso de extracción';
      }
    },
    cerrar(cambios = false) {
      this.$emit('cerrar', cambios);
    },
    borrarMuestra(m) {
      const ix = this.muestras.indexOf(m);
      this.muestras.splice(ix, 1);
    },
  },
};
</script>
